import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IGetFlightDimensionalWeightRepoData = { weight: number };

export type IGetFlightDimensionalWeightRepoResponse = IRepoResponse<200, IGetFlightDimensionalWeightRepoData> | IRepoResponse<400 | 500, string>;

export type IGetFlightDimensionalWeightRepo = IRepo<[{ flightId: string | number }], IGetFlightDimensionalWeightRepoResponse>;

export const GetFlightDimensionalWeightRepoType = Symbol.for('GetFlightDimensionalWeightRepo');

@bind(GetFlightDimensionalWeightRepoType)
export class GetFlightDimensionalWeightRepo implements IGetFlightDimensionalWeightRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ flightId }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/flights/calculate', { flight_id: flightId }) });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: {
            weight: result.data.data,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);

      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
